<div class="no-field-space">
    <sc-padding>
        <form [formGroup]="optionFormGroup">
            <mat-form-field appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.external-key"></sc-dictionary-label>
                </mat-label>
                <input matInput formControlName="externalKey" name="externalKey" [readonly]="true" [maxlength]="50">
            </mat-form-field>
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-dictionary-field class="input-name" [model]="transportOption.name"
                (dictionaryChanged)="onDictionaryChange($event)"
                [labelDictionaryKey]="'tmc-yard.entity.transport-option.name'" [required]="true"
                [maxlength]="255"></sc-dictionary-field>
            <sc-content-spacer vertical></sc-content-spacer>
            <mat-form-field appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport-option.mark"></sc-dictionary-label>
                </mat-label>
                <input matInput formControlName="mark" name="mark" [required]="false" [maxlength]="255">
            </mat-form-field>

            <sc-content-spacer vertical></sc-content-spacer>

            <sc-dictionary-text-field [rows]="3" [model]="transportOption.hintDriver" [maxlength]="255" defaultLabel="Text"
                labelDictionaryKey="tmc-yard.entity.transport-option.hintDriver"
                (dictionaryChanged)="onHintDriverChanged($event)">
            </sc-dictionary-text-field>

            <sc-content-spacer vertical></sc-content-spacer>

            <sc-checkbox-field formControlName="allwaysShowHint" labelDictionaryKey="tmc-yard.entity.transport-option.alwaysShowHint"></sc-checkbox-field>
        </form>
    </sc-padding>
</div>
